import BookItButtonContainer from './BookItButtonContainer';

export default BookItButtonContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/BookItButton/index.js